import { ApplyTaxesContext } from "../providers/ApplyTaxesProvider";
import { useContext } from "react";

export default function useApplyTaxesContext() {
  return useContext(ApplyTaxesContext);
}
